export default __webpack_public_path__ + "static/electrum-459bb762a0dd070c04b32e19a2813cae.png";